import { useEffect, useRef } from "react"

export function useWhyDidYouUpdate(name: string, props: object) {
  // Get a mutable ref object where we can store props for comparison
  const previousProps = useRef<object>({})

  useEffect(() => {
    if (previousProps.current) {
      // Get all keys from previous and current props
      const allKeys = Object.keys({ ...previousProps.current, ...props })
      // Use this object to keep track of changed props
      const changesObj: Record<string, { from: any; to: any }> = {}

      allKeys.forEach((key) => {
        // If previous is different from current
        if (
          previousProps.current[key as keyof object] !==
          props[key as keyof object]
        ) {
          // Add to changesObj
          changesObj[key] = {
            from: previousProps.current[key as keyof object],
            to: props[key as keyof object],
          }
        }
      })

      // If changesObj not empty then output to console
      if (Object.keys(changesObj).length) {
        console.log("[why-did-you-update]", name, changesObj)
      }
    }

    // Finally update previousProps with current props for next hook call
    previousProps.current = props
  })
}
